var render, staticRenderFns
import script from "./SchoolSecret.vue?vue&type=script&lang=js&"
export * from "./SchoolSecret.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSecret.vue?vue&type=style&index=0&id=b0e040e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports